import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {PropType} from 'vue'
import {Dict} from "@/interface/common";
import {VADescriptionsItem} from "./typings";


export default /*@__PURE__*/_defineComponent({
  __name: 'VADescriptions',
  props: {
  title: String,
  column: {
    type: Number,
    default: 3,
  },
  options: Object as PropType<Array<VADescriptionsItem>>,
  data: Object as PropType<Dict>,
},
  setup(__props) {



const formatValue = (data: any, key: string): string => {
  // 对时间进行处理，转化为本地时间
  if (key === 'updated_at' || key === 'created_at') {
    const d = data[key]
    // 数据可能是 null 或 undefined
    if (d) {
      return new Date(d.toString()).toLocaleString()
    }
    return ""
  }
  return data[key]
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createBlock(_component_a_descriptions, {
    title: __props.title,
    column: __props.column
  }, {
    extra: _withCtx(() => [
      _renderSlot(_ctx.$slots, "extra")
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
        return (_openBlock(), _createBlock(_component_a_descriptions_item, {
          key: item.label,
          label: item.label,
          span: item.span || 1
        }, {
          default: _withCtx(() => [
            (item.slot && item.slot !== '')
              ? _renderSlot(_ctx.$slots, item.slot, { key: 0 })
              : (item.tagType === 'a')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    style: _normalizeStyle(item.style)
                  }, _toDisplayString(__props.data[item.key]), 5))
                : (item.tagType === 'tag')
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 2,
                      color: item.colors[__props.data[item.key]]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatValue(__props.data, item.key)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      style: _normalizeStyle(item.style)
                    }, _toDisplayString(formatValue(__props.data, item.key)), 5))
          ]),
          _: 2
        }, 1032, ["label", "span"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["title", "column"]))
}
}

})